import * as React from 'react';
import { Box, Text, Button } from '@wix/design-system';
import { POS_SideEffectEvents } from '../POSSolutionWidget';
export const POSExpertWidget = _ref => {
  let {
    context
  } = _ref;
  const onExpertButtonClick = React.useCallback(() => {
    context.onWidgetAction(POS_EXPERT_WIDGET, {
      action: 'book-a-call-button-click'
    });
    context.emitSideEffect(POS_SideEffectEvents.posBookButtonClick, {
      origin: 'ai assistant',
      pageState: 'book a call'
    });
  }, [context]);
  React.useEffect(() => {
    context.onWidgetAction(POS_EXPERT_WIDGET, {
      action: 'appeared'
    });
  }, []);
  return /*#__PURE__*/React.createElement(Box, {
    gap: "8px",
    border: "1px solid red",
    borderRadius: "12px",
    borderColor: "B40",
    padding: "SP2",
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    align: "space-between",
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "bold"
  }, "Talk to POS expert"), /*#__PURE__*/React.createElement(Button, {
    size: "tiny",
    as: "a",
    priority: "secondary",
    target: "_blank",
    onClick: onExpertButtonClick,
    href: "https://www.wix.com/pos/book-a-call-wix-pos/booking-calendar/book-a-call-with-a-pos-expert?utm_campaign=vir_POS_BO_posPage-AiAssistant_bookCall&referral=aiAssistant-bookACall"
  }, "Book a call")), /*#__PURE__*/React.createElement(Text, {
    size: "tiny"
  }, "Schedule a free call with our POS experts to get more info about our point of sale."));
};
export const POS_EXPERT_WIDGET = 'POS_EXPERT_WIDGET';
//# sourceMappingURL=POSExpertWidget.js.map